import useSWR from "swr";
import DealerService from "services/DealerService";

/**
 * Hook to fetch a single dealer based on _dlid from localStorage.
 * Returns the first dealer found, or null if not available.
 */
const useDealerSwr = () => {
    const dlid = localStorage.getItem("_dlid");

    const shouldFetch = !!dlid;

    const { data, error, isLoading } = useSWR(
        shouldFetch ? ["dealer", dlid] : null,
        async () => {
            const response = await DealerService.getAll(dlid);
            const dealers = response?.data || [];
            return dealers.length > 0 ? dealers[0] : null;
        },
        { revalidateOnFocus: false }
    );

    return {
        dealer: data,
        isLoading,
        isError: !!error,
    };
};

export default useDealerSwr;
